import React, { useEffect, useState } from "react";
import { Alert, Box, CircularProgress, Typography } from "@mui/material";

const MessagePreviewPage: React.FC = () => {
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const url = sessionStorage.getItem("messagePreviewUrl");
    setPreviewUrl(url);
  }, []);

  if (!previewUrl) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 8 }}>
        <Typography color="text.secondary">No preview available.</Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#f0f2f5",
        gap: 0.5,
      }}>
      <Typography variant="h6" sx={{ color: "#555", fontWeight: 600 }}>
        Message Preview
      </Typography>
      <Alert severity="info" sx={{ width: 450 }}>
        Note: Empty iframe? Please log into Facebook and try again.
      </Alert>
      {loading && <CircularProgress />}
      <iframe
        src={previewUrl}
        title="Message Preview"
        width={500}
        style={{
          border: "none",
          overflow: "auto",
          display: loading ? "none" : "block",
          height: "80vh",
        }}
        allow="autoplay"
        onLoad={() => setLoading(false)}
      />
    </Box>
  );
};

export default MessagePreviewPage;
